import { Node, mergeAttributes } from '@tiptap/core';

export const DefinitionDescription = Node.create({
  name: 'definitionDescription',
  group: 'definitionDescription',
  content: 'inline*',
  parseHTML() {
    return [{ tag: 'dd' }];
  },
  renderHTML({ HTMLAttributes }) {
    return ['dd', mergeAttributes(HTMLAttributes), 0];
  },
});
